import { fromJS } from "immutable";

import TYPE from "../../constants/type";

const initialState = fromJS({
  detail: {},
  isFetching: false,
});

export default function systemReducer(state = initialState, action) {
  switch (action.type) {
    case TYPE.SYSTEM.GET_SYSTEM_BY_ID_LOADING: {
      return state.merge({
        isFetching: true,
      });
    }

    case TYPE.SYSTEM.GET_SYSTEM_BY_ID_SUCCESS: {
      return state.merge({
        detail: action.payload,
        isFetching: false,
      });
    }

    case TYPE.SYSTEM.GET_SYSTEM_BY_ID_FAILURE: {
      return state.merge({
        isFetching: false,
      });
    }

    case TYPE.SYSTEM.UPDATE_SYSTEM_LOADING: {
      return state.merge({
        isFetching: true,
      });
    }

    case TYPE.SYSTEM.UPDATE_SYSTEM_SUCCESS: {
      return state.merge({
        detail: action.payload,
        isFetching: false,
      });
    }

    case TYPE.SYSTEM.UPDATE_SYSTEM_FAILURE: {
      return state.merge({
        isFetching: false,
      });
    }

    default:
      return state;
  }
}

